import { render, staticRenderFns } from "./CorrectionJournal.vue?vue&type=template&id=3f108c40&scoped=true"
import script from "./CorrectionJournal.vue?vue&type=script&lang=js"
export * from "./CorrectionJournal.vue?vue&type=script&lang=js"
import style0 from "./CorrectionJournal.vue?vue&type=style&index=0&id=3f108c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f108c40",
  null
  
)

export default component.exports